import React from "react";
import {
  useLocation
} from "react-router-dom";
import { MdOutlineDashboard, MdPerson, MdPowerSettingsNew } from "react-icons/md";
import { ImBooks } from "react-icons/im"
import { getAuth, signOut } from 'firebase/auth'

import MenuItem from './MenuItem'

const Menu = () => {
  const { pathname } = useLocation();

  return (
    <nav className="mt-6 flex-1">
      <div>
        <MenuItem label='Dashboard' link='/'  active={pathname === '/'} icon={<MdOutlineDashboard size={18} />} iconClass='text-purple-500' />
        <MenuItem label='Mon compte' link='/profile' active={pathname === '/profile'} icon={<MdPerson size={18} />} iconClass='text-sky-500' />
        <MenuItem label='Mes formations' link='/training' active={pathname.includes('training')} icon={<ImBooks size={18} /> } iconClass='text-amber-500' />
        <MenuItem label='Se déconnecter' icon={<MdPowerSettingsNew className='text-red-500'/>} onClick={(e: any) => {
          e.preventDefault()
          signOut(getAuth())
        }} />
      </div>
    </nav>
  );
}

export default Menu